.state {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 1.25rem;
  border: 1px solid var(--danger-text);
  border-radius: 0.5rem;
  background-color: var(--danger-surface);
  color: var(--danger-text);
}

.title {
  margin: 0;
  font-size: 1.125rem;
}

.detail {
  margin: 0;
  line-height: 1.5;
}

/* The mockup's centred `.state` for a whole screen: no frame, a round danger glyph, a 16/600 title. */
.state[data-layout="page"] {
  align-items: center;
  padding: var(--space-12) var(--space-6);
  border: 0;
  background: transparent;
  color: var(--text);
  text-align: center;
}

.icon {
  display: grid;
  place-items: center;
  inline-size: 40px;
  block-size: 40px;
  margin-block-end: var(--space-2);
  border-radius: 50%;
  background: var(--danger-surface);
  color: var(--danger-text);
}

.state[data-layout="page"] .title {
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.state[data-layout="page"] .detail {
  max-inline-size: 44ch;
  color: var(--text-muted);
}
